import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import { getUserContactPageUrl } from '..';

const UserLink = (_ref) => {
  let {
    userId,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["userId", "children"]);

  const userHref = getUserContactPageUrl(userId);
  return /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
    href: userHref,
    children: children
  }));
};

export default UserLink;